import { Injectable, inject } from '@angular/core';
import { GtmService } from './gtm.service';

@Injectable()
export class UserTrackingService {
  private gtmService = inject(GtmService);

  setLoginEvent(userId: string): void {
    const loginEvent = {
      event: 'login',
      user_id: userId,
    };

    this.gtmService.pushTag(loginEvent);
  }
}
